<template>
  <UICard title="Advisor">
    <UICheckbox v-model="advisorMode" label="Enable Advisor mode" />
  </UICard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useUserSettingsStore } from '@/store/user/settings'

import { UICard } from '@ui/core'
import { UICheckbox } from '@ui/controllers'

const userSettingsStore = useUserSettingsStore()

const advisorMode = computed<boolean>({
  get() {
    return userSettingsStore.getAdvisorMode
  },
  set(value) {
    userSettingsStore.setAdvisorMode(value)
  },
})
</script>
